<section class="inspWrap" aria-label="get inspired">
    <header class="inspHead">
        <div class="inspHeadText">
            <span class="inspEyebrow">{{ 'ai.home_inspire_eyebrow' | transloco }}</span>
            <h2 class="inspTitle">{{ 'ai.home_inspire_title' | transloco }}</h2>
        </div>
        <div class="inspHeadCtrls">
            <button type="button" class="inspNav" (click)="stripPrev()" [attr.aria-label]="'previous'">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <button type="button" class="inspNav" (click)="stripNext()" [attr.aria-label]="'next'">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>
    </header>

    <!-- ngx-flicking carousel (same lib as the dialog filmstrip + templates).
         Cards are pure <app-inspire-thumb> images — no <video> here — so
         rendering every panel is cheap; first frames are captured in the
         background by HomeInspireService. Clicking a card opens the mp4. -->
    <ngx-flicking #stripFlick
                  class="inspStripMain"
                  [options]="{ bound: true, align: 'prev', moveType: 'snap', preventClickOnDrag: true }">
        @for (video of videos; track video.file) {
            <figure flicking-panel class="inspCard" (click)="openLightbox(video)">
                <div class="inspCardMedia">
                    <app-inspire-thumb [video]="video"></app-inspire-thumb>
                    <div class="inspCardShade" aria-hidden="true"></div>
                    <div class="inspCardPlay" aria-hidden="true">
                        <mat-icon>play_arrow</mat-icon>
                    </div>
                </div>
                <figcaption class="inspCardCap">{{ video.label }}</figcaption>
            </figure>
        }
    </ngx-flicking>
</section>

@if (lightbox) {
    <div class="inspLightbox" role="dialog" aria-modal="true" (click)="closeLightbox()">
        <button type="button" class="inspLightboxClose" (click)="closeLightbox()" [attr.aria-label]="'close'">
            <mat-icon>close</mat-icon>
        </button>
        <div class="inspLightboxBody" (click)="$event.stopPropagation()">
            <div class="inspLightboxStage">
                <video class="inspLightboxVideo"
                       [src]="lightbox.url"
                       muted
                       [muted]="true"
                       loop
                       autoplay
                       playsinline
                       disablepictureinpicture
                       preload="auto"
                       (loadstart)="onLightboxBuffering()"
                       (waiting)="onLightboxBuffering()"
                       (canplay)="onLightboxReady()"
                       (playing)="onLightboxReady()"
                       (error)="onLightboxReady()"
                       (stalled)="onLightboxReady()"
                       (loadedmetadata)="forceMute($event)"
                       (play)="forceMute($event)"
                       (timeupdate)="onTimeUpdate($event)"></video>

                @if (lightboxLoading) {
                    <div class="inspLightboxLoader" role="status" aria-live="polite">
                        <div class="inspLoaderOrb" aria-hidden="true">
                            <span class="inspLoaderRing"></span>
                            <span class="inspLoaderRing inspLoaderRing2"></span>
                            <span class="inspLoaderCore"></span>
                        </div>
                        <span class="inspLoaderText">{{ 'ai.home_inspire_loading' | transloco }}</span>
                    </div>
                }

                <div class="inspLightboxCap">{{ lightbox.label }}</div>
            </div>

            <!-- Filmstrip: every clip as a first-frame thumbnail so the
                 user can skip to any one without closing the dialog. Uses
                 ngx-flicking (same carousel lib as the templates page) for
                 smooth drag + snap, with Arrow-plugin prev/next buttons. -->
            <ngx-flicking class="inspStripFlick"
                          [options]="{ bound: true, align: 'prev', moveType: 'snap', preventClickOnDrag: true }"
                          [plugins]="stripPlugins">
                @for (video of videos; track video.file) {
                    <button flicking-panel
                            type="button"
                            class="inspThumb"
                            [class.inspThumbActive]="video.file === lightbox.file"
                            (click)="selectLightbox(video)"
                            [attr.aria-label]="video.label">
                        <span class="inspThumbMedia">
                            <app-inspire-thumb [video]="video"></app-inspire-thumb>
                        </span>
                        <span class="inspThumbLabel">{{ video.label }}</span>
                    </button>
                }

                <span class="flicking-arrow-prev inspStripArrow inspStripArrowPrev">
                    <mat-icon>chevron_left</mat-icon>
                </span>
                <span class="flicking-arrow-next inspStripArrow inspStripArrowNext">
                    <mat-icon>chevron_right</mat-icon>
                </span>
            </ngx-flicking>
        </div>
    </div>
}
